<script setup lang="ts">
import { onMounted } from 'vue'

import { useAuth0 } from '@auth0/auth0-vue'

import { Spinner } from '#ui/spinner'

definePage({
  meta: { requiresAuth: false, title: 'Sign in' },
})

const { loginWithRedirect } = useAuth0()

onMounted(() => {
  loginWithRedirect()
})
</script>

<template>
  <main class="grid min-h-svh place-items-center p-6">
    <div class="flex flex-col items-center gap-3 text-center" role="status">
      <Spinner class="size-5 text-muted-foreground" />
      <p class="text-sm text-muted-foreground">Redirecting you to sign in…</p>
    </div>
  </main>
</template>
